export default "__VITE_ASSET__C5y5zPp0__"